import React from 'react';
import { colors } from '@styles/core-styles/theme';

export const BulbIcon: React.FC<{
	color?: string;
	width?: string;
	height?: string;
}> = ({ color = colors.orange, width = '100%', height = '100%' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 54 55" fill="none">
			<path
				d="M27 3.87207V6.31175M42.3797 10.3031L40.6711 12.0279M48.75 25.8292H46.3333M7.66667 25.8292H5.25M13.3289 12.0279L11.6203 10.3031"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M20.25 47.7861H33.75"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M34.895 35.9855C37.6985 33.623 39.4821 30.0696 39.4821 26.0906C39.4821 18.9655 33.7644 13.2139 26.7411 13.2139C19.7177 13.2139 14 18.9655 14 26.0906C14 30.0696 15.7837 33.623 18.5871 35.9855C19.7424 36.959 20.6458 38.4256 20.6458 40.1487C20.6458 41.2286 21.5212 42.104 22.6011 42.104H30.881C31.9609 42.104 32.8363 41.2286 32.8363 40.1487C32.8363 38.4256 33.7397 36.959 34.895 35.9855ZM35.8616 37.1325C34.9591 37.893 34.3363 38.9686 34.3363 40.1487C34.3363 42.057 32.7893 43.604 30.881 43.604H22.6011C20.6928 43.604 19.1458 42.057 19.1458 40.1487C19.1458 38.9686 18.523 37.893 17.6205 37.1325C14.4911 34.4953 12.5 30.5277 12.5 26.0906C12.5 18.1505 18.8759 11.7139 26.7411 11.7139C34.6062 11.7139 40.9821 18.1505 40.9821 26.0906C40.9821 30.5277 38.991 34.4953 35.8616 37.1325Z"
				fill={color}
			/>
			<path
				d="M31.4135 26.3952L31.3593 26.821L31.699 27.0834L32.8737 27.991L31.8452 29.7382L30.4434 29.1799L30.0509 29.0235L29.7138 29.2782C29.3965 29.5179 29.0784 29.7074 28.7114 29.8561L28.3114 30.0183L28.2506 30.4457L28.0448 31.8932H25.9583L25.7525 30.4457L25.6908 30.0116L25.2822 29.8524C24.9272 29.7141 24.6129 29.5226 24.2892 29.2782L23.9521 29.0235L23.5597 29.1799L22.1579 29.7382L21.1294 27.991L22.3041 27.0834L22.6438 26.821L22.5896 26.3952C22.5636 26.1913 22.547 26.0085 22.547 25.8289C22.547 25.6483 22.5638 25.4579 22.5903 25.2367L22.6414 24.8098L22.2989 24.55L21.1311 23.6641L22.1585 21.9186L23.562 22.4721L23.9479 22.6243L24.2819 22.3783C24.6104 22.1365 24.9265 21.9441 25.2822 21.8055L25.6908 21.6463L25.7525 21.2122L25.9583 19.7646H28.0448L28.2506 21.2122L28.3123 21.6463L28.7208 21.8055C29.0766 21.9441 29.3927 22.1365 29.7211 22.3783L30.0551 22.6243L30.441 22.4721L31.8445 21.9186L32.872 23.6641L31.7042 24.55L31.3617 24.8098L31.4128 25.2367C31.4393 25.4579 31.4561 25.6483 31.4561 25.8289C31.4561 26.0085 31.4394 26.1913 31.4135 26.3952ZM24.7586 28.0505C25.3558 28.6369 26.1628 28.9639 27.0015 28.9639C27.8402 28.9639 28.6473 28.6369 29.2444 28.0505C29.842 27.4637 30.1803 26.6648 30.1803 25.8289C30.1803 24.993 29.842 24.1942 29.2444 23.6074C28.6473 23.021 27.8402 22.6939 27.0015 22.6939C26.1628 22.6939 25.3558 23.021 24.7586 23.6074C24.161 24.1942 23.8228 24.993 23.8228 25.8289C23.8228 26.6648 24.161 27.4637 24.7586 28.0505Z"
				fill={color}
				stroke={color}
				stroke-width="1.5"
			/>
		</svg>
	);
};
